module.exports = __webpack_public_path__ + "ed8a9f5470c66fac97af8a1f7749bdee.svg";